export default class FooterAdGoogle extends React.Component {
  constructor (props) {
    super(props)
  }

  componentDidMount() {
    if (this.props.show_ads)
      (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    if (this.props.show_ads) {
      return ( // МТ: Регионы футер
        <div style={{margin: "15px auto", textAlign: "center"}}>
          <ins className="adsbygoogle"
               style={{display: 'none', minWidth: '728px', minHeight: '90px'}}
               data-ad-client="ca-pub-3673800954269220"
               data-ad-slot="9932199198"
               data-ad-format="auto"
               data-full-width-responsive="true"/>
        </div>
      );
    }
    return <div></div>;
  }
}
